import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPropertiesRoutine } from 'state/properties/properties.routines';
import { propertiesStateSelector } from 'state/properties/properties.selectors';

const useProperties = () => {
    const dispatch = useDispatch();
    const { isFetchingProperties, properties } = useSelector(propertiesStateSelector);

    useEffect(() => {
        if (dispatch) dispatch(getPropertiesRoutine.trigger());
    }, [dispatch]);

    return {
        properties,
        isFetchingProperties
    };
};

export default useProperties;
